import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import PayrollApi from '../generated/api/Payroll';

export default (service: Servicelayer) => ({
  ...PayrollApi(service),

  // Add custom calls here

});
